import CitiesBootstrapper from './CitiesBootstrapper';

export default CitiesBootstrapper;
